export default "__VITE_ASSET__DnNpKE_0__"